export default {
  requiredForDidacticBriefcase: 'This object is required for the functioning of the didactic briefcase.',
}
